import React from 'react';
import { humanizeTimezone } from 'works/legacy/lib/date-helper';
import { Button, Divider, Typography } from 'antd';
import { AlignedInfo, HistoryDropDown, Icon, Link } from '@common/components';
import { OrganizationBusinessType } from '@institutions/types';
import { buildDialogUrl } from '@common/services';
import { useCurrentMembership } from '@identity/hooks';

const { Title } = Typography;

type OrganizationFacilityDetailsSectionProps = {
  facility?: OrganizationBusinessType;
};

export function OrganizationFacilityDetailsSection({
  facility,
}: OrganizationFacilityDetailsSectionProps) {
  const { canUpdateOrganizationBusiness } = useCurrentMembership();

  return (
    <section className="organization-facility__details">
      <div className="organization-facility__details-title">
        <Title level={3}>Details</Title>
        {canUpdateOrganizationBusiness && (
          <Link to={buildEditDrawerUrl(facility?.id)}>
            <Button type="link" data-testid="edit-organization-facility">
              <Icon icon="pencil" size="md" color="elm" />
            </Button>
          </Link>
        )}
      </div>
      <Divider />
      <AlignedInfo
        content={[
          ['Address', facility?.address],
          ['ZIP Code', facility?.postalCode],
          ['City', facility?.city],
          ['State', facility?.stateCode],
          ['Time Zone', humanizeTimezone(facility?.timeZone)],
        ]}
      />
      <HistoryDropDown data={facility?.history || []} hrVisible={false} />

      <style jsx>{`
        .organization-facility__details-title {
          margin-top: 24px;
          display: flex;
        }
      `}</style>
    </section>
  );
}

function buildEditDrawerUrl(facilityId = '') {
  return buildDialogUrl('organization-facility-edit-drawer', {
    props: {
      facilityId,
    },
  });
}
